export const defaultAddress = {
  countryId: 'US',
  regionId: '',
  city: '',
  address1: '',
  address2: '',
  zipCode: '',
  valid: false
};
